export const baseUrl = `${process.env.REACT_APP_API_URL}`;

// users  urls
export const getAllUserList = baseUrl + "/api/User/all-users";
export const createNewUserUrl = baseUrl + "/api/PortalUsers";

export const changeUserPasswordUrl =
  baseUrl + "/api/PortalUsers/me/actions/change-password";
export const getRegistrationList = baseUrl + "/api/User/verifications";

export const getVerificationFullKycList =
  baseUrl + "/api/User/verifications/fullkyc";
export const getVerificationPartialKycList =
  baseUrl + "/api/User/verifications/partialkyc";
export const getVerificationNoKycList =
  baseUrl + "/api/User/verifications/nokyc";

export const getUpdatedList = baseUrl + "/api/User/updates";
export const getRejectedList = baseUrl + "/api/User/rejections";
export const getVerificationList = baseUrl + "/api/User/verification/";

export const userListAndSearch = baseUrl + "/api/User/search";
export const userSearch = baseUrl + "/api/User/search/";
export const registrations = baseUrl + "/api/User/registrations/search";
export const registrationsearch = baseUrl + "/api/User/registrations/search";
export const updates = baseUrl + "/api/User/updates/search";
export const updatesearch = baseUrl + "/api/User/updates/search";
export const rejection = baseUrl + "/api/User/rejections/search";
export const rejectionsearch = baseUrl + "/api/User/rejections/search";

export const getAllNonRegisteredUsers = baseUrl + "/api/cardholder/search";
